import { Fragment } from "react/jsx-runtime";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { TooltipTitle, UIKits } from "../../../Constants/Constants";
import BasicTooltip from "./BasicTooltip";
import ColoredTooltip from "./ColoredTooltip";
import DisabledTooltip from "./DisabledTooltip";
import FilledTooltip from "./FilledTooltip";
import HtmlTooltip from "./HtmlTooltip";
import LightTooltips from "./LightTooltips";
import TooltipDirection from "./TooltipDirection";
import SVGTooltips from "./SVGTooltips";
import OutlineSVGTooltips from "./OutlineSVGTooltips";

const TooltipContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={TooltipTitle} parent={UIKits} />
      <Container fluid>
        <Row>
          <BasicTooltip />
          <ColoredTooltip />
          <LightTooltips />
          <TooltipDirection />
          <HtmlTooltip />
          <FilledTooltip />
          <DisabledTooltip />
          <SVGTooltips />
          <OutlineSVGTooltips />
        </Row>
      </Container>
    </Fragment>
  );
};
export default TooltipContainer;
